export enum Background {
    gray = 'bg-gray-100',
    image = 'image-background-light',
}
